<template>
  <div
    :class="efClass"
    class="popArea awardsPopup"
  >
    <canvas
      id="my-custom-canvas"
      :width="WIDTH"
      :height="HEIGHT"
    />
    <div
      class="defaultSect2 awardsPopArea"
      ref="defaultSect2"
    >
      <div class="divInner">
        <div class="topPop">
          <div class="awardsTopText">
            <span>We always</span>
            <span>show</span>

            <span>the best performance</span>
            <span>and leadership.</span>
          </div>

          <div class="a_rightWinner">
            <span class="hotPink">
              <span>{{ awardPlay.score }}</span> Winner
            </span>
          </div>
        </div>
        <div
          v-for="(list, idx) in award.data"
          :key="idx"
          class="a_listConArea"
        >
          <div class="yearArea">
            <strong class="a_topYear">{{ list.years }}</strong>
            <div class="yearLine" />
          </div>
          <div class="a_ListCon">
            <div
              v-for="(target, i) in list.list"
              :key="'award' + i"
              class="a_listArray"
            >
              <p class="a_listTitle">{{ target.target }}</p>
              <ul>
                <li
                  v-for="(itm, j) in target.content"
                  :key="'sub-' + j"
                >
                  <span class="a_listName">{{ itm.subject }}</span>
                  <span
                    class="a_listType"
                    v-html="itm.awarded"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="congratulation">
      <div class="squareBox square1">
        <span class="box_red" />
        <span class="box_orange" />
        <span class="box_blue" />
        <span class="box_purple" />
        <span class="box_sky" />
        <span class="box_green" />
        <span class="box_fluore" />
        <span class="box_yellow" />

        <span class="box_green" />
        <span class="box_sky" />
        <span class="box_orange" />
        <span class="box_purple" />
        <span class="box_blue" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import award from '@/assets/json/award.json'
import VueConfetti from 'vue-confetti'
import { Expo, TweenLite } from 'gsap/all'
Vue.use(VueConfetti)
export default {
  name: 'AwardsPop',
  data () {
    return {
      award,
      awardPlay: { score: 0, complete: true },
      efClass: '',
      HEIGHT: 0
    }
  },
  components: {
  },
  computed: {
    ...mapState('common', {
      awardsPop: state => state.awardsPop
    }),
    awardEnd () {
      let c = 0
      this.award.data.map((itm) => {
        itm.list.map((list) => {
          list.content.map(_ => {
            c++
          })
        })
      })
      return c
    },
    WIDTH () {
      return window ? window.innerWidth : 0
    }
  },
  watch: {
    awardsPop (newValue) {
      if (newValue) {
        this.efClass = 'active'
        setTimeout(_ => {
          this.HEIGHT = this.$refs.defaultSect2.scrollHeight
          this.$confetti.start({
            particlesPerFrame: 0.5,
            customCanvas: true,
            canvasId: 'my-custom-canvas',
            particles: [{
              size: 3,
              dropRate: 6,
              type: 'rect',
              colors: ['DodgerBlue', 'OliveDrab', 'Gold', 'pink', 'SlateBlue', 'lightblue', 'Violet', 'PaleGreen', 'SteelBlue', 'SandyBrown', 'Chocolate', 'Crimson']
            }]
          })
        }, 1000)
        if (this.awardPlay.complete) {
          this.awardPlay.complete = false
          TweenLite.to(this.awardPlay, 3, { score: this.awardEnd, roundProps: 'score', delay: 1, ease: Expo.easeOut })
        }
      } else {
        this.$confetti.stop()
        this.efClass = 'leave'
        setTimeout(() => {
          this.efClass = ''
        }, 600)
        this.awardPlay.score = 0
        this.awardPlay.complete = true
      }
    }
  },
  methods: {
  },
  mounted () {
  },
  destroyed () {
  }
}
</script>

<style>
  #my-custom-canvas{
    position: absolute;
  }
</style>
